import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import { showNotification as showNotificationAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

class CreatePdf extends Component {
    // handleClick = () => {
    //     // console.log("EINAI TEST");
    //     // console.log(this.props);
    //     const html =  document.getElementById('all-answers');
    //     html2canvas(document.body).then(function(canvas) {
    //         // document.body.appendChild(canvas);
    //     });
    //     const input = document.getElementById('all-answers');
    //     const sumH = document.getElementById('all-answers').clientHeight;
    //     const sumW = document.getElementById('all-answers').clientWidth;
    //     html2canvas(input)
    //     .then((canvas) => {
    //       const imgData = canvas.toDataURL('image/png');
    //       const pdf = new jsPDF({orientation: 'landscape', unit: 'mm', format: [sumW, 255]});
    //       const width = pdf.internal.pageSize.getWidth();
    //       const height = pdf.internal.pageSize.getHeight();
    //       for (let i=1;i<Math.ceil(sumH/height);i++){
    //         if(i==1){
    //           pdf.setPage(i);
    //           pdf.addImage(imgData, 'PNG', 0, 0);
    //         } else {
    //           pdf.addPage(width, height);
    //           pdf.addImage(imgData, 'PNG', 0, -(i-1)*height);
    //         }
    //       }
    //       pdf.save("download.pdf");
    //     });
    // }

    handleClick = (e) => {
        var pdfParent =  e.target.closest('pdfblock');
        var elements = document.querySelectorAll("pdfblock");
        const html =  document.getElementById('all-answers');
        html2canvas(pdfParent).then(function(canvas) {

        });
        const input = pdfParent;
        html2canvas(input)
        .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({orientation: 'landscape', unit: 'mm', format: [450, 255]});
            // const pdf = new jsPDF({orientation: 'landscape', unit: 'mm', format: [sumW, sumH]});
            pdf.setPage(1);
            pdf.addImage(imgData, 'PNG', 10, 5);
            pdf.save("download.pdf");
        });
    }

    render() {
        return <FlatButton label="create PDF" onClick={this.handleClick.bind(this)} />;
    }
}

CreatePdf.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
})(CreatePdf);



// WEBPACK FOOTER //
// ./src/pages/custom/CreatePdf.js